import { z } from "zod";

export const resetPasswordBody = z.object({
  newPassword: z.string(),
  recoveryCode: z.string(),
});

export const createPasswordBody = z.object({
  password: z.string(),
  token: z.string(),
});
